/**
 * @file 标记他人号码
 * @author
 */
import React from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import PropTypes from 'prop-types';
import {Button, Carousel} from 'antd';

import {recordProxy, getQueryString} from '../../util';
import needLoginList from '../../constants/needLoginList';

import img1 from './imgs/1.png';
import img2 from './imgs/1-1.png';
import img3 from './imgs/2.png';
import img4 from './imgs/2-2.png';

import './markErr.less';

class MarkErr extends React.Component {
    constructor(prop) {
        super(prop);
        this.state = {
            value: '',
            off: false,
            phone: '',
            pageObj: {},
            urlParam: ''
        };
    }

    componentDidMount() {
        const searchUrlPhone = getQueryString('phone');
        if (searchUrlPhone) {
            this.setState({
                urlParam: '?phones=' + encodeURIComponent(JSON.stringify([{phone: searchUrlPhone}]))
            });
        }
        // if (this.props.match.params.key) {
        //     this.props.updateMark({
        //         phone: this.props.match.params.key,
        //         curStep: 2
        //     });
        // }
        // window.scrollTo(0, 0);
    }
    // componentWillUnmount() {
    //     // this.props.cleanMark();
    // }
    login = () => {
        const isDev = window.location.href.indexOf('haoma.baidu.com') > -1 ? false : true;
        const ele = document.createElement('a');
        ele.href = `https://passport${isDev ? '.qatest' : ''}.baidu.com/v2/?login&u=${
            window.location.href
        }`;
        ele.click();
    };
    jump = (item) => {
        const {userInfo = {}} = this.props;
        recordProxy('url-' + item.routerPath.replace('/', ''), 'click', '立即前往');
        if (needLoginList.includes(item.routerPath) && userInfo.code !== 200) {
            this.login();
        } else {
            this.props.history.push(item.routerPath + this.state.urlParam);
        }
    };
    render() {
        // const {curStep} = this.state;
        const cardList = [
            {
                logo: img1,
                cardTitle: '号码标记申诉',
                cardDesc: '号码被标记为骚扰、推销，可申诉取消',
                cardShowLogo: img2,
                cardShowTitle: '北京  中国移动',
                cardShowTip: '184 **** 6512',
                goUrl: '/appeal?pagef=markErr'
            }, {
                logo: img3,
                cardTitle: '标记类型修改',
                cardDesc: '修改标记类型，如：快递电话标记为保险',
                cardShowLogo: img4,
                cardShowTitle: '金融理财',
                cardShowTip: '北京',
                tag: '用户标记',
                goUrl: '/mark?pagef=markErr'
            }
        ];
        return (
            <div className={'mark-err-page'}>
                <div className="banner">
                    <Carousel className="custom-carousel-class" autoplay>
                        <div className="carousel-item">
                            <div className="item-info-wrapper">
                                <p className="title">标记错误</p>
                                <p className="title-tip">以下号码信息存在错误，请选择要进行的服务</p>
                            </div>
                        </div>
                    </Carousel>
                </div>
                <div className="line-content">
                    <div className="line1"></div>
                    <div className="line-title">选择服务</div>
                    <div className="line2"></div>
                </div>
                <div className="card-content">
                    {cardList.map((val, key) => {
                        return <div className="card-item" key={key}>
                            <div className="card-logo">
                                <img src={val.logo} />
                            </div>
                            <div className="card-title">{val.cardTitle}</div>
                            <div className="card-desc">{val.cardDesc}</div>
                            <div className="card-tip">完成效果</div>

                            <div className="card-show">
                                <div className="card-show-logo">
                                    <img src={val.cardShowLogo} />
                                </div>
                                <div className="card-show-cont">
                                    <div className="card-show-title">
                                        {val.cardShowTitle}
                                        {val.tag && <span className="card-show-tag">{val.tag}</span>}
                                    </div>
                                    <div className="card-show-tip">{val.cardShowTip}</div>
                                </div>
                            </div>
                            <Button
                                className="goBtn"
                                type="primary"
                                onClick={() => this.jump({routerPath: val.goUrl})}
                            >立即前往</Button>
                        </div>;
                    })}
                </div>
            </div>
        );
    }

}
function mapStateToProps(state) {
    return {
        userInfo: state.userInfo,
        // markData: state.markReducer
    };
}

function mapDispatchToProps() {
    return {
    };
}
MarkErr.propTypes = {
    history:PropTypes.object,
    userInfo: PropTypes.object,

};
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(MarkErr));
